import { PapiDaSharedDeviationSubmitInit } from '@wix/da-papi-types';
import { useDefaultQuestions } from './useDefaultQuestions';
import {
  OriginalDeviationFieldName,
  OriginalDeviationFormFields,
} from '../types';

const DEFAULT_VALUES = {
  [OriginalDeviationFieldName.DELIVERY_TIME]: 7,
  [OriginalDeviationFieldName.DISPLAY_RESOLUTION]: 0,
  [OriginalDeviationFieldName.PRICE]: 20,
  [OriginalDeviationFieldName.PROGRESS_IS_VISIBLE]: true,
  [OriginalDeviationFieldName.ADD_WATERMARK]: false,
};

export function useDefaultValues(
  initResponse?: PapiDaSharedDeviationSubmitInit
): Partial<OriginalDeviationFormFields> {
  const defaultQuestions = useDefaultQuestions();
  const deviation = initResponse?.deviation;

  if (deviation) {
    const { tags, displayIndex } = initResponse;
    let description = deviation.extended?.descriptionText;
    if (
      description &&
      description.html.type === 'writer' &&
      description.html.markup === ''
    ) {
      description = undefined;
    }
    return {
      [OriginalDeviationFieldName.TITLE]: deviation.title,
      [OriginalDeviationFieldName.DESCRIPTION]: description
        ? () => JSON.stringify(description)
        : undefined,
      [OriginalDeviationFieldName.MATURE_CONTENT]: deviation.isMature,
      [OriginalDeviationFieldName.NO_AI]: deviation.isAiUseDisallowed,
      [OriginalDeviationFieldName.IS_AI_GENERATED]: deviation.isAiGenerated,
      [OriginalDeviationFieldName.TAGS]: tags?.map(tag => tag.name),
      [OriginalDeviationFieldName.PRICE]:
        deviation.extended?.originals?.basePrice,
      [OriginalDeviationFieldName.DELIVERY_TIME]:
        deviation.extended?.originals?.estDeliveryDays,
      [OriginalDeviationFieldName.DISPLAY_RESOLUTION]: displayIndex,
      [OriginalDeviationFieldName.OPEN_FOR_ORDERS]:
        deviation.extended?.originals?.isOpen,
      [OriginalDeviationFieldName.PROGRESS_IS_VISIBLE]:
        deviation.extended?.originals?.showInProgressCount,
      [OriginalDeviationFieldName.ADD_WATERMARK]:
        deviation.extended?.hasWatermark,
      [OriginalDeviationFieldName.QUESTIONS]:
        deviation.extended?.originals?.questionnaire,
    };
  } else {
    return {
      ...DEFAULT_VALUES,
      questions: defaultQuestions,
    };
  }
}
